import request from '@/utils/http'

export interface ExplanatoryVideoItem {
  /** 视频标题 */
  title: string
  /** 视频跳转地址 */
  vidioUrl: string
}

export interface CommonProblemItem {
  /** 问题 */
  question: string
  /** 答案 */
  answer: string
}

export interface ModeGuideItem {
  /** 条目小标题（加粗展示，如：系统化日常练习） */
  label: string
  /** 条目正文 */
  text: string
}

export interface ModeGuideSection {
  /** 小节标题 */
  title: string
  /** paragraph：普通段落；list：多条内容 */
  type: 'paragraph' | 'list'
  /** paragraph 类型的段落内容（list 类型旧数据兼容：按换行分隔的字符串） */
  content?: string | string[]
  /** list 类型的条目列表（label 加粗 + text 正文） */
  items?: ModeGuideItem[]
}

export interface ModeGuide {
  /** 模式标识（如 LIST / SPEED_MEMO） */
  key: string
  /** 模式标题（如：列表模式指南） */
  title: string
  /** 角标文案（如：NEW） */
  badge?: string
  /** 模式下的内容小节 */
  sections: ModeGuideSection[]
}

export interface QuestionGuideData {
  /** 题型介绍 */
  questionIntroduce: string
  /** 练习建议 */
  questionSuggest: string
  /** 讲解视频列表 */
  explanatoryVideoList: ExplanatoryVideoItem[]
  /** 练习常见问题列表 */
  commonProblemList: CommonProblemItem[]
  /** 模式指南列表（题库综合指南 category=9001 时返回，如：列表模式/速记模式） */
  modeGuides?: ModeGuide[]
}

/**
 * 获取题型练习指导
 * @param category 题型ID
 */
export const getQuestionGuideApi = (category: number | string) => {
  return request.get<QuestionGuideData>('/api/postsV2/questionGuide', { category })
}
